// Ficheros con constantes de los nombres de las variables para evitar que se repitan

// GETTERS
export const ALL_CIUDADES = 'ciudades/ALL_CIUDADES';
export const CIUDAD = 'ciudad/CIUDAD';

export const ALL_INDICADORES = 'indicadores/ALL_INDICADORES';
export const ALL_INDICADORES_MANUAL = 'indicadores/ALL_INDICADORES_MANUAL';
export const ALL_INDICADORES_AUTO = 'indicadores/ALL_INDICADORES_AUTO';
export const INDICADOR_CIUDAD = 'indicadores/INDICADOR_CIUDAD';

export const ALL_INDICES = 'indices/ALL_INDICES';
export const INDICE_CIUDAD = 'indices/INDICE_CIUDAD';

export const ALL_INDICES_TEMATICOS = 'indicesTematicos/ALL_INDICES_TEMATICOS';
export const INDICE_TEMATICO_CIUDAD = 'indicesTematicos/INDICE_TEMATICO_CIUDAD';
export const INDICE_TEMATICO = 'indicesTematicos/INDICE_TEMATICO';
export const ALL_INDICES_TEMATICOS_VISIBLES = 'indicesTematicos/ALL_INDICES_TEMATICOS_VISIBLES';

export const ALL_AUEOBJETIVES = 'aue/ALL_AUEOBJETIVES';
export const AUEOBJETIVE_CIUDAD = 'aue/AUEOBJETIVE_CIUDAD';
export const AUE_SELECTED = 'aue/AUE_SELECTED';

export const ALL_ODSOBJETIVOS = 'ods/ALL_ODSOBJETIVOS';
export const ODSOBJETIVO_CIUDAD = 'ods/ODSOBJETIVO_CIUDAD';

export const ALL_USUARIOS = 'usuarios/ALL_USUARIOS';

export const LOOP_INDICATORS = 'loop/LOOP_INDICATORS';

// MUTATIONS
export const MUTATE_ALL_CIUDADES = 'ciudades/MUTATE_ALL_CIUDADES';
export const MUTATE_CIUDAD = 'ciudad/MUTATE_CIUDAD';

export const MUTATE_ALL_INDICADORES = 'indicadores/MUTATE_ALL_INDICADORES';
export const MUTATE_ALL_INDICADORES_MANUAL = 'indicadores/MUTATE_ALL_INDICADORES_MANUAL';
export const MUTATE_ALL_INDICADORES_AUTO = 'indicadores/MUTATE_ALL_INDICADORES_AUTO';

export const MUTATE_INDICADOR_CIUDAD = 'indicadores/MUTATE_INDICADOR_CIUDAD';

export const MUTATE_ALL_INDICES = 'indices/MUTATE_ALL_INDICES';
export const MUTATE_INDICE_CIUDAD = 'indices/MUTATE_INDICE_CIUDAD';

export const MUTATE_ALL_INDICES_TEMATICOS = 'indicesTematicos/MUTATE_ALL_INDICES_TEMATICOS';
export const MUTATE_INDICE_TEMATICO_CIUDAD = 'indicesTematicos/MUTATE_INDICE_TEMATICO_CIUDAD';
export const MUTATE_INDICE_TEMATICO = 'indicesTematicos/MUTATE_INDICE_TEMATICO';
export const MUTATE_ALL_INDICES_TEMATICOS_VISIBLES = 'indicesTematicos/MUTATE_ALL_INDICES_TEMATICOS_VISIBLES';

export const MUTATE_ALL_AUEOBJETIVES = 'aue/MUTATE_ALL_AUEOBJETIVES';
export const MUTATE_AUEOBJETIVE_CIUDAD = 'aue/MUTATE_AUEOBJETIVE_CIUDAD';
export const MUTATE_AUE_SELECTED = 'aue/MUTATE_AUE_SELECTED';

export const MUTATE_ALL_ODSOBJETIVOS = 'ods/MUTATE_ALL_ODSOBJETIVOS';
export const MUTATE_ODSOBJETIVO_CIUDAD = 'ods/MUTATE_ODSOBJETIVO_CIUDAD';

export const MUTATE_ALL_USUARIOS = 'usuarios/MUTATE_ALL_USUARIOS';

export const MUTATE_SET_LOOP_INDICATORS = 'loop/MUTATE_SET_LOOP_INDICATORS';

// ACTIONS
export const ACTION_GET_ALL_CIUDADES = 'ciudades/ACTION_GET_ALL_CIUDADES';
export const ACTION_GET_ALL_CIUDADES_FILTERED = 'ciudades/ACTION_GET_ALL_CIUDADES_FILTERED';
export const ACTION_GET_CIUDAD = 'ciudad/ACTION_GET_CIUDAD';
export const ACTION_SAVE_CIUDAD = 'ciudad/ACTION_SAVE_CIUDAD';
export const ACTION_SAVE_NEW_CIUDAD = 'ciudad/ACTION_SAVE_NEW_CIUDAD';
export const ACTION_DELETE_CIUDAD = 'ciudad/ACTION_DELETE_CIUDAD';
export const ACTION_GET_CIUDAD_ZONAS = 'ciudad/ACTION_GET_CIUDAD_ZONAS';

export const ACTION_GET_ALL_INDICADORES = 'indicadores/ACTION_GET_ALL_INDICADORES';
export const ACTION_GET_INDICADOR = 'indicadores/ACTION_GET_INDICADOR';
export const ACTION_GET_INDICADOR_INDICE_TEMATICO = 'indicadores/ACTION_GET_INDICADOR_INDICE_TEMATICO';
export const ACTION_GET_INDICADOR_CIUDAD = 'indicadores/ACTION_GET_INDICADOR_CIUDAD';
export const ACTION_GET_INDICADOR_SATELITAL = 'indicadores/ACTION_GET_INDICADOR_SATELITAL';
export const ACTION_GET_INDICADOR_INDICE_CIUDAD = 'indicadores/ACTION_GET_INDICADOR_INDICE_CIUDAD';
export const ACTION_GET_INDICADOR_ZONA = 'indicadores/ACTION_GET_INDICADOR_ZONA';
export const ACTION_GET_DATA_INDICADORAUE = 'indicadores/ACTION_GET_DATA_INDICADORAUE';
export const ACTION_GET_INDICADORAUE_OBJETIVOESPECIFICO = 'indicadores/ACTION_GET_INDICADORAUE_OBJETIVOESPECIFICO';
export const ACTION_GET_INDICADORSATELITAL_OBJETIVOESPECIFICO = 'indicadores/ACTION_GET_INDICADORSATELITAL_OBJETIVOESPECIFICO';
export const ACTION_GET_FASES_INDICADORAUE = 'indicadores/ACTION_GET_FASES_INDICADORAUE';
export const ACTION_GET_CARACTERES_INDICADORAUE = 'indicadores/ACTION_GET_CARACTERES_INDICADORAUE';
export const ACTION_GET_PLAZOS_INDICADORAUE = 'indicadores/ACTION_GET_PLAZOS_INDICADORAUE';
export const ACTION_GET_ACCIONES_ASOCIADAS = 'indicadores/ACTION_GET_ACCIONES_ASOCIADAS';
export const ACTION_GET_ACCIONES_ASOCIADAS_SATELITALES = 'indicadores/ACTION_GET_ACCIONES_ASOCIADAS_SATELITALES';
export const ACTION_GET_PERIODICIDAD = 'indicadores/ACTION_GET_PERIODICIDAD';
export const ACTION_SAVE_INDICADORAUE = 'indicadores/ACTION_SAVE_INDICADORAUE';
export const ACTION_SAVE_INDICADOR_DOCUMENTOPDF = 'indicadores/ACTION_SAVE_INDICADOR_DOCUMENTOPDF';
export const ACTION_SAVE_DATOS_INTERMEDIOS = 'indicadores/ACTION_SAVE_DATOS_INTERMEDIOS';
export const ACTION_SAVE_DATOS_CUALITATIVOS = 'indicadores/ACTION_SAVE_DATOS_CUALITATIVOS';
export const ACTION_SAVE_INDICADOR = 'indicadores/ACTION_SAVE_INDICADOR';
export const ACTION_SAVE_INDICADOR_MANUAL = 'indicadores/ACTION_SAVE_INDICADOR_MANUAL';
export const ACTION_EDIT_INDICADOR_MANUAL = 'indicadores/ACTION_EDIT_INDICADOR_MANUAL';
export const ACTION_GET_IS_ACCION_ASOCIADA = 'indicadores/ACTION_GET_IS_ACCION_ASOCIADA';
export const ACTION_GET_CSV_INDICADOR = 'indicadores/ACTION_GET_CSV_INDICADOR';
export const ACTION_GET_INDICADORAUE_OBJETIVOESPECIFICO_TARJETASINDICADORESACCIONES = 'indicadores/ACTION_GET_INDICADORAUE_OBJETIVOESPECIFICO_TARJETASINDICADORESACCIONES';
export const ACTION_GET_INDICADOR_TARJETA = 'indicadores/ACTION_GET_INDICADOR_TARJETA';
export const ACTION_GET_DETALLE_INDICADOR_AUE = 'indicadores/ACTION_GET_DETALLE_INDICADOR_AUE';
export const ACTION_GET_INDICADORESAUE_CIUDAD = 'indicadores/ACTION_GET_INDICADORESAUE_CIUDAD';
export const ACTION_GET_ALL_INDICADORES_OBSERVATORIO = 'indicadores/ACTION_GET_ALL_INDICADORES_OBSERVATORIO';

export const ACTION_GET_ALL_INDICES = 'indices/ACTION_GET_ALL_INDICES';

export const ACTION_GET_ALL_INDICES_TEMATICOS = 'indicesTematicos/ACTION_GET_ALL_INDICES_TEMATICOS';
export const ACTION_GET_INDICE_TEMATICO = 'indicesTematicos/ACTION_GET_INDICE_TEMATICO';
export const ACTION_SAVE_NEW_INDICE_TEMATICO = 'indicesTematicos/ACTION_SAVE_NEW_INDICE_TEMATICO';
export const ACTION_SAVE_INDICE_TEMATICO = 'indicesTematicos/ACTION_SAVE_INDICE_TEMATICO';
export const ACTION_DELETE_INDICE_TEMATICO = 'indicesTematicos/ACTION_DELETE_INDICE_TEMATICO';

export const ACTION_GET_ALL_AUEOBJETIVES = 'aue/ACTION_GET_ALL_AUEOBJETIVES';
export const ACTION_GET_AUEOBJETIVE_CIUDAD = 'aue/ACTION_GET_AUEOBJETIVE_CIUDAD';
export const ACTION_GET_ACCIONES_OBJETIVO_ESPECIFICO = 'aue/ACTION_GET_ACCIONES_OBJETIVO_ESPECIFICO';
export const ACTION_SAVE_AUEOBJETIVE_CIUDAD = 'aue/ACTION_SAVE_AUEOBJETIVE_CIUDAD';
export const ACTION_GET_ACCION = 'aue/ACTION_GET_ACCION';

export const ACTION_GET_ALL_ODSOBJETIVOS = 'ods/ACTION_GET_ALL_ODSOBJETIVOS';
export const ACTION_GET_ODSOBJETIVO_CIUDAD = 'ods/ACTION_GET_ODSOBJETIVO_CIUDAD';
export const ACTION_SAVE_ODSOBJETIVO_CIUDAD = 'ods/ACTION_SAVE_ODSOBJETIVO_CIUDAD';
export const ACTION_GET_OBJETIVOS_ESPECIFICOS = 'ods/ACTION_GET_OBJETIVOS_ESPECIFICOS';
export const ACTION_GET_OBJETIVOS_ESPECIFICOS_LINEAS_ACTUACION = 'ods/ACTION_GET_OBJETIVOS_ESPECIFICOS_LINEAS_ACTUACION';

export const ACTION_GET_ALL_USUARIOS = 'usuarios/ACTION_GET_ALL_USUARIOS';
export const ACTION_SAVE_USUARIO = 'usuario/ACTION_SAVE_USUARIO';
export const ACTION_DELETE_USUARIO = 'usuario/ACTION_DELETE_USUARIO';
export const ACTION_FILTER_USUARIOS = 'usuarios/ACTION_FILTER_USUARIOS';

export const ACTION_GET_INFORMES_DIAGNOSTICO = 'diagnostico/ACTION_GET_INFORMES_DIAGNOSTICO';
export const ACTION_SAVE_DOCUMENTOPDF = 'ACTION_SAVE_DOCUMENTOPDF';
export const ACTION_SAVE_INFORME_DIAGNOSTICO = 'diagnostico/ACTION_SAVE_INFORME_DIAGNOSTICO';
export const ACTION_DELETE_INFORME_DIAGNOSTICO = 'diagnostico/ACTION_DELETE_INFORME_DIAGNOSTICO';
